import $ from 'jquery';
import { getState, modifyState } from '~src/state';

export const zoomOut = () => {
  const canvasZoom = getState('currentCanvasZoom');
  const initialCanvasZoom = getState('initialCanvasZoom');

  // Return early if already at initial zoom
  if (canvasZoom <= initialCanvasZoom) {
    return;
  }

  // Use 1/1.15 as the zoom out factor to perfectly counteract zoom in
  const newCanvasZoom = Math.max(canvasZoom * (1 / 1.15), initialCanvasZoom);
  modifyState('currentCanvasZoom', newCanvasZoom);

  // Get parent and child elements
  const parent = $('#canvas-container')[0];
  const child = $('#canvas-zoom')[0];

  // Get dimensions
  const parentHeight = parent.offsetHeight;
  const parentWidth = parent.offsetWidth;
  const childHeight = child.offsetHeight;
  const childWidth = child.offsetWidth;

  let marginTop =
    Math.abs((parentHeight - childHeight * newCanvasZoom) / 2) * 2.2;

  // hack to solve an issue that when zooming out, the same amount of steps of zoom in
  // the positioning is never the same due to small error
  if (marginTop < 100) {
    marginTop = 0;
  }

  // Only apply margin-left if scaled canvas width exceeds container width
  const scaledWidth = childWidth * newCanvasZoom;
  const marginLeft =
    scaledWidth > parentWidth
      ? Math.abs((parentWidth - childWidth * newCanvasZoom) / 2) * 2.2
      : 0;

  $('#canvas-zoom').css({
    transform: `scale(${newCanvasZoom})`,
    'margin-top': marginTop + 'px',
    'margin-left': marginLeft + 'px',
  });

  // Update spell check control sizes for all textboxes
  if (window.canvas) {
    window.canvas.getObjects().forEach((obj) => {
      if (obj.type === 'textbox' && obj.updateControlSizes) {
        obj.updateControlSizes();
      }
    });
  }
};
